import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 4a1 1 0 0 1 1 1v14a1 1 0 0 1-1.707.707l-3-3a1 1 0 1 1 1.414-1.414L9 16.586V5a1 1 0 0 1 1-1m4 16a1 1 0 0 1-1-1V5a1 1 0 0 1 1.707-.707l3 3a1 1 0 0 1-1.414 1.414L15 7.414V19a1 1 0 0 1-1 1",
      clipRule: "evenodd"
    }
  )
);
var SvgSortOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SortOutlined_default = SvgSortOutlined;

export { SortOutlined_default as default };
